import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFirestore, addDoc, collection, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { UserContext } from '../../contexts/UserProvider';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

export const CreateExpenseScreen = () => {
    const { groupId } = useParams();
    const { userData } = useContext(UserContext);
    const navigate = useNavigate();

    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleCreateExpense = async (e) => {
        e.preventDefault();
        if (!description || !amount) {
            setErrorMessage('Please fill in all fields.');
            return;
        }

        try {
            const firestore = getFirestore();
            const groupRef = doc(firestore, `groups/${groupId}`);
            const groupSnap = await getDoc(groupRef);

            if (!groupSnap.exists()) {
                setErrorMessage('Group not found.');
                return;
            }

            const groupData = groupSnap.data();
            const numberOfMembers = groupData.members.length;
            const amountPerMember = parseFloat(amount) / numberOfMembers;

            const membersOwing = groupData.members
                .filter(member => member.userId !== userData.userId)
                .map(member => ({
                    byUserId: userData.userId,
                    toUserId: member.userId,
                    amountOwed: amountPerMember
                }));

            const expensesRef = collection(firestore, `groups/${groupId}/expenses`);

            await addDoc(expensesRef, {
                description,
                amount: parseFloat(amount),
                currency: 'USD',
                docCreated: serverTimestamp(),
                lastModified: serverTimestamp(),
                createdBy: userData.userId,
                membersOwing
            });

            navigate(`/groups/${groupId}`);
        } catch (error) {
            console.error('Error creating expense:', error);
            setErrorMessage('Failed to create expense.');
        }
    };

    return (
        <Box sx={{ maxWidth: 400, margin: 'auto', padding: 2 }}>
            <form onSubmit={handleCreateExpense}>
                {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
                <TextField
                    label="Description"
                    variant="outlined"
                    fullWidth
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    margin="normal"
                />
                <TextField
                    label="Amount"
                    variant="outlined"
                    fullWidth
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    margin="normal"
                    type="number"
                />
                <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary" 
                    fullWidth
                    sx={{ marginTop: 2 }}
                >
                    Create Expense
                </Button>
            </form>
        </Box>
    );
};
